import React from 'react'
import './AthleteCalendar.css'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import Iframe from 'react-iframe'

const athleteReduxCalendar = 'athleteCalendar'

var calendar = null

const AthleteCalendar = (props) => {

    if (props.athleteCalendar) {

        if (props.athleteCalendar.calendar && props.athleteCalendar.calendar !== '') {

            const calId = props.athleteCalendar.calendar.replace('@', '%40')
            const athleteCalOne = 'https://calendar.google.com/calendar/embed?&wkst=2'
            const athleteCalTwo = '&src='
            const athleteCalSrc = calId
            const athleteCalLast = '&ctz=America%2FChicago&color=%23865A5A&showPrint=0&showTz=0&showCalendars=0&showDate=1&showNav=1&showTabs=0&showTitle=0&ctz=America%2FChicago'
        
            const calendarString = athleteCalOne + athleteCalTwo + athleteCalSrc + athleteCalLast
        
            calendar =
            
                <div className="AthleteCalendar">
                    <Iframe
                        url={calendarString}
                        width="80%"
                        height="600px"
                        display="block"
                        position="relative"
                    />
                </div>
            return (

                calendar
            )

        } else {

            return null
        }

    } else {

        return null
    }
}

const mapStateToProps = (state) => {
    
    return {
        athleteCalendar: state.firestore.data.athleteCalendar
    }
  }

export default compose(
  connect(mapStateToProps),
    firestoreConnect((props) => [
        {
            collection: 'athletes',
            doc: props.id,
            subcollections: [
                { collection: 'profile', doc: 'socialMedia' }
            ],
            storeAs: athleteReduxCalendar
        }
  ])
)(AthleteCalendar)